/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeterValuesCommand } from '../../models/meter-values-command';

export interface ApiOcppOperationMeterValuesPost$Json$Params {
  chargerId?: string;
  isFinished?: boolean;
      body?: MeterValuesCommand
}

export function apiOcppOperationMeterValuesPost$Json(http: HttpClient, rootUrl: string, params?: ApiOcppOperationMeterValuesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, apiOcppOperationMeterValuesPost$Json.PATH, 'post');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.query('isFinished', params.isFinished, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

apiOcppOperationMeterValuesPost$Json.PATH = '/api/OcppOperation/meterValues';
